import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';

const MOBILE_MAX_WIDTH = 551;
const TABLET_MAX_WIDTH = 1000;
const MOBILE_CATEGORY_COUNT = 4;
const TABLET_CATEGORY_COUNT = 3;
const DESKTOP_CATEGORY_COUNT = 4;

/**
 * React Hook that returns the how many categories to show
 * based on the window size
 *
 * @typedef {CalculateCategoriesCount} CalculateCategoriesCount
 * @returns number - indicating how many categories to show
 */

const useCalculateCategoriesCount = () => {
    const isMobile = useIsNarrowerThan(MOBILE_MAX_WIDTH);
    const isTabletOrNarrower = useIsNarrowerThan(TABLET_MAX_WIDTH);
    const categoryCount = isMobile
        ? MOBILE_CATEGORY_COUNT
        : isTabletOrNarrower
          ? TABLET_CATEGORY_COUNT
          : DESKTOP_CATEGORY_COUNT;

    return { categoryCount, isMobile };
};

export default useCalculateCategoriesCount;
